import script from "./AboutMeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutMeView.vue?vue&type=script&setup=true&lang=ts"

import "./AboutMeView.vue?vue&type=style&index=0&id=15b9f2a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15b9f2a8"]])

export default __exports__